import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Input } from 'core-components/library/inputs'
import { updateAssortmentItem } from 'partner360/features/assortment/assortmentSlice'
import { IAssortmentItem } from 'partner360/features/assortment/models/data/IAssortmentItem'

import { TRANSLATION_KEYS } from '../../../../translations'

import styles from './ProductCodes.module.scss'

interface IProductCodesProps {
  isEditMode: boolean
  item: IAssortmentItem
}

export const ProductCodes: FC<IProductCodesProps> = ({ isEditMode, item }) => {
  const dispatch = useAppDispatch()

  const changeProductCode = useCallback(
    (productCode: string) => {
      dispatch(
        updateAssortmentItem({
          ...item,
          ProductCodeName: productCode,
        })
      )
    },
    [dispatch, item]
  )

  if (isEditMode) {
    return (
      <Input
        value={item.ProductCodeName}
        onChange={changeProductCode}
        label={<Translation text={TRANSLATION_KEYS.item.productCode} />}
      />
    )
  }

  return (
    <div className={styles.root}>
      <div className={styles.readLabel}>
        <Translation text={TRANSLATION_KEYS.item.productCode} />
      </div>
      <div>{item.ProductCodeName}</div>
    </div>
  )
}
